(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["par3-coming-soon"] && !Shopify.designMode) return;
  try {
    if (!window.customElements.get('par3-coming-soon')) {
    window.customElements.define('par3-coming-soon', class extends HTMLElement {
      connectedCallback() {
        this._launch = Number(this.dataset.launch) * 1000;

        if (!this._launch) {
          return;
        }

        this._numbers = {};
        this.querySelectorAll('[data-unit]').forEach((element) => {
          this._numbers[element.dataset.unit] = element;
        });

        this._tick();
        this._interval = setInterval(() => this._tick(), 1000);
      }

      disconnectedCallback() {
        clearInterval(this._interval);
      }

      _tick() {
        const left = Math.floor((this._launch - Date.now()) / 1000);

        if (left <= 0) {
          this.setAttribute('data-ended', '');
          clearInterval(this._interval);
          return;
        }

        const parts = {
          d: Math.floor(left / 86400),
          h: Math.floor((left % 86400) / 3600),
          m: Math.floor((left % 3600) / 60),
          s: left % 60
        };

        Object.entries(parts).forEach(([unit, value]) => {
          if (this._numbers[unit]) {
            this._numbers[unit].textContent = String(value).padStart(2, '0');
          }
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["par3-gift-recipient"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('par3-gift-recipient')) {
    customElements.define('par3-gift-recipient', class extends HTMLElement {
      connectedCallback() {
        if (this.ready) return;
        this.ready = true;
        const fields = this.querySelector('[data-recipient-fields]');
        const email = this.querySelector('[data-email]');
        const date = this.querySelector('[data-date]');
        const today = new Intl.DateTimeFormat('sv-SE', { timeZone: 'Europe/Riga' }).format(new Date());
        const last = new Date(today + 'T12:00:00Z');
        last.setUTCDate(last.getUTCDate() + 90);
        date.min = today;
        date.max = last.toISOString().slice(0, 10);
        const update = () => {
          const direct = this.querySelector('input[value="Saņēmējam"]').checked;
          fields.hidden = !direct;
          fields.querySelectorAll('input,textarea').forEach(el => { el.disabled = !direct; });
          email.required = direct;
        };
        this.querySelectorAll('input[type="radio"]').forEach(el => el.addEventListener('change', update));
        const form = this.closest('form');
        if (form) form.addEventListener('submit', event => {
          if (!form.reportValidity()) { event.preventDefault(); event.stopImmediatePropagation(); }
        }, true);
        update();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
